<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <div class="card-smallHeader card-header-action" v-b-toggle.collapse1>
        <i class="fa fa-search mr-2"></i>
        <strong>Recherche</strong>
        <div class="card-header-actions">
          <span class="when-opened"><i class="icon-arrow-down"></i></span>
          <span class="when-closed"><i class="icon-arrow-up"></i></span>
        </div>
      </div>
      <b-collapse id="collapse1">
        <b-card-body>
          <b-form v-on:submit.prevent="searchByFilters">
            <b-row>
              <b-col sm="3">
                <b-form-group>
                  <label for="oap"><strong>OAP</strong></label>
                  <multiselect v-model="selectedOaps"
                              selectLabel='Appuyer sur entrer pour sélectionner'
                              selectedLabel='Sélectionné' deselectLabel='Appuyer sur entrer pour désélectionner'
                              :close-on-select="false"
                              tag-placeholder="Choisissez un ou plusieurs OAP" placeholder="Choisissez un ou plusieurs OAP"
                              label="name" track-by="id" id="oap"
                              :options="oapOptions" :multiple="true"
                              :taggable="true">
                  </multiselect>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group>
                  <label for="oag"><strong>OAG</strong></label>
                  <multiselect v-model="selectedOags"
                              selectLabel='Appuyer sur entrer pour sélectionner'
                              selectedLabel='Sélectionné' deselectLabel='Appuyer sur entrer pour désélectionner'
                              :close-on-select="false"
                              tag-placeholder="Choisissez un ou plusieurs OAG" placeholder="Choisissez un ou plusieurs OAG"
                              label="name" track-by="id" id="oag"
                              :options="oagOptions" :multiple="true"
                              :taggable="true">
                  </multiselect>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group>
                  <label for="version"><strong>Version</strong></label>
                  <b-form-input type="text" id="version" v-model="version"
                                :class="{hasError: errors.version !== ''}"></b-form-input>
                  <span class="field-error">{{ errors.version }}</span>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="3">
                <b-form-group>
                  <template slot="label"><b>Secteur :</b></template>
                  <b-form-checkbox-group
                    id="check-group-2-3"
                    v-model="secteur"
                    name="check-secteur"
                  >
                    <b-form-checkbox value="ess">ESS</b-form-checkbox>
                    <b-form-checkbox value="interpro">INTERPRO</b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="3">
                <b-form-group>
                  <label for="categorySelect"><strong>Catégorie</strong></label>
                  <b-form-select
                    id="categorySelect"
                    :plain="true"
                    :options="categoryOptions"
                    v-model="selectedCategory"
                    :class="{hasError: errors.selectedCategory !== ''}"
                    class="mr-3">
                    <template #first>
                      <b-form-select-option :value="null" disabled>-- Sélectionnez une catégorie --</b-form-select-option>
                    </template>
                  </b-form-select>
                  <span class="field-error">{{ errors.selectedCategory }}</span>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group v-if="showSousCategory">
                  <label for="sousCategorieSelect"><strong>Sous-catégorie</strong></label>
                  <b-input-group>
                    <b-form-select
                      id="sousCategorieSelect"
                      :plain="true"
                      :options="sousCategoriesOptions"
                      v-model="selectedSousCategory"
                      :class="{hasError: errors.selectedSousCategory !== ''}"
                      class="mr-3">
                      <template #first>
                        <b-form-select-option :value="null" disabled>-- Sélectionnez une sous-catégorie --</b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-input-group>
                  <span class="field-error">{{ errors.selectedSousCategory }}</span>
                </b-form-group>
                <b-form-group v-else>
                  <label for="gammeSelect"><strong>Famille produit</strong></label>
                  <b-form-select
                    id="gammeSelect"
                    :plain="true"
                    :options="gammeOptions"
                    v-model="selectedGamme"
                    :class="{hasError: errors.selectedGamme !== ''}"
                    class="mr-3">
                    <template #first>
                      <b-form-select-option :value="-1" disabled>-- Sélectionnez une famille produit --</b-form-select-option>
                    </template>
                  </b-form-select>
                  <span class="field-error">{{ errors.selectedGamme }}</span>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group v-if="showCodeProduit">
                  <label for="codeProduitSelect"><strong>Code produit</strong></label>
                  <b-input-group>
                    <b-form-select
                      id="codeProduitSelect"
                      :plain="true"
                      :options="codeProduitOptions"
                      v-model="selectedCodeProduit"
                      :class="{hasError: errors.selectedCodeProduit !== ''}"
                      class="mr-3">
                      <template #first>
                        <b-form-select-option :value="null" disabled>-- Sélectionnez un code produit --</b-form-select-option>
                      </template>
                    </b-form-select>
                    <span class="field-error">{{ errors.selectedCodeProduit }}</span>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group>
                  <label for="garantieSelect"><strong>Garantie</strong></label>
                  <multiselect v-model="selectedGaranties"
                    selectLabel='Appuyer sur entrer pour sélectionner' selectedLabel='Sélectionné'
                    deselectLabel='Appuyer sur entrer pour désélectionner' :close-on-select="false"
                    tag-placeholder="Choisissez une ou plusieurs garantie(s)" placeholder="Choisissez une ou plusieurs garantie(s)"
                    label="text" track-by="value"
                    :options="garantieOptions" :multiple="true"
                    :taggable="true">
                  </multiselect>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="3">
                <b-form-group>
                  <label for="is_visible_client"><strong>Visible par le client</strong></label>
                  <b-form-checkbox id="is_visible_client" v-model="is_visible_client"></b-form-checkbox >
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group>
                  <label for="statusSelect"><strong>Statut</strong></label>
                  <b-form-select
                    id="statusSelect"
                    :plain="true"
                    :options="statusOptions"
                    v-model="selectedStatus"
                    :class="{hasError: errors.selectedStatus !== ''}"
                    class="mr-3">
                    <template #first>
                      <b-form-select-option :value="null" disabled>-- Sélectionnez un statut --</b-form-select-option>
                    </template>
                  </b-form-select>
                  <span class="field-error">{{ errors.selectedStatus }}</span>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group>
                  <label for="rubriqueSelect"><strong>Rubrique</strong></label>
                  <b-form-select
                    id="rubriqueSelect"
                    :plain="true"
                    :options="rubriqueOptions"
                    v-model="selectedRubrique"
                    :class="{hasError: errors.selectedRubrique !== ''}"
                    class="mr-3">
                    <template #first>
                      <b-form-select-option :value="null" disabled>-- Sélectionnez une rubrique --</b-form-select-option>
                    </template>
                  </b-form-select>
                  <span class="field-error">{{ errors.selectedRubrique }}</span>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group>
                  <label for="sousRubriqueSelect"><strong>Sous-rubrique</strong></label>
                  <b-form-select
                    id="sousRubriqueSelect"
                    :plain="true"
                    :options="sousRubriqueOptions"
                    v-model="selectedSousRubrique"
                    :class="{hasError: errors.selectedSousRubrique !== ''}"
                    class="mr-3">
                    <template #first>
                      <b-form-select-option :value="null" disabled>-- Sélectionnez une sous-rubrique --</b-form-select-option>
                    </template>
                  </b-form-select>
                  <span class="field-error">{{ errors.selectedSousRubrique }}</span>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="3">
                <b-form-group>
                  <label for="date_publication_journal_officiel"><strong>Date de publication JO</strong></label>
                  <b-form-input type="date" id="date_publication_journal_officiel" v-model="date_publication_journal_officiel"
                                :class="{hasError: errors.date_publication_journal_officiel !== ''}"></b-form-input>
                  <span class="field-error">{{ errors.date_publication_journal_officiel }}</span>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group>
                  <label for="date_debut"><strong>Date début de visibilité</strong></label>
                  <b-form-input type="date" id="date_debut" v-model="date_debut"
                                :class="{hasError: errors.date_debut !== ''}"></b-form-input>
                  <span class="field-error">{{ errors.date_debut }}</span>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group>
                  <label for="date_fin"><strong>Date fin de visibilité</strong></label>
                  <b-form-input type="date" id="date_fin" v-model="date_fin"
                                :class="{hasError: errors.date_fin !== ''}"></b-form-input>
                  <span class="field-error">{{ errors.date_fin }}</span>
                </b-form-group>
              </b-col>
            </b-row>
            <hr>
            <div class="table-wrapper">
              <b-link v-b-toggle.collapseCriteria>Voir + de critères</b-link>
              <b-collapse id="collapseCriteria">
                <div style="margin-bottom:15px;margin-top:15px;">
                  <b-row>
                    <b-col sm="4">
                      <b-form-group>
                        <label for="typeSelect"><strong>Type</strong></label>
                        <b-form-select
                          id="typeSelect"
                          :plain="true"
                          :options="typeOptions"
                          v-model="selectedType"
                          :class="{hasError: errors.selectedType !== ''}"
                          class="mr-3">
                          <template #first>
                            <b-form-select-option :value="null" disabled>-- Sélectionnez un type --</b-form-select-option>
                          </template>
                        </b-form-select>
                        <span class="field-error">{{ errors.selectedType }}</span>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group>
                        <label for="segmentSelect"><strong>Segment</strong></label>
                        <b-form-select
                          id="segmentSelect"
                          :plain="true"
                          :options="segmentOptions"
                          v-model="selectedSegment"
                          :class="{hasError: errors.selectedSegment !== ''}"
                          class="mr-3">
                          <template #first>
                            <b-form-select-option :value="null" disabled>-- Sélectionnez un segment --</b-form-select-option>
                          </template>
                        </b-form-select>
                        <span class="field-error">{{ errors.selectedSegment }}</span>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4">
                      <b-form-group>
                        <label for="libelle"><strong>Libellé</strong></label>
                        <b-form-input type="text" id="libelle" v-model="libelle"
                                      :class="{hasError: errors.libelle !== ''}"></b-form-input>
                        <span class="field-error">{{ errors.libelle }}</span>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group>
                        <label for="code"><strong>Code</strong></label>
                        <b-form-input type="text" id="code" v-model="code"
                                      :class="{hasError: errors.code !== ''}"></b-form-input>
                        <span class="field-error">{{ errors.code }}</span>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </div>
              </b-collapse>
            </div>
            <div slot="footer" style="margin-top:15px;">
              <b-button type="button" @click.prevent="clearSearchForm()" size="md" variant="secondary" class="mr-1">
                <i class="fa fa-eraser"></i> Effacer
              </b-button>
              <b-button type="enter" @click.prevent="searchByFilters" size="md" variant="primary">
                <i class="fa fa-search"></i> Rechercher
              </b-button>
              <span class="field-error">{{ errors.critere_recherche }}</span>
            </div>
          </b-form>
          <strong><hr style="border:1px solid #1e8eb5"></strong>
          <documents-table :tableEntry="tableParam" ref="documents_table" :datas="dataToTransmit"></documents-table>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken, getUser } from '@/utils/auth'
import { isEmpty } from "@/utils/fileHelper"
// import DetailsDocument from "@/components/Bibliotheque/Document/DetailsDocument"
// import HistoriqueDocument from "@/components/Bibliotheque/Document/HistoriqueDocument"
// import FichiersDocument from "@/components/Bibliotheque/Document/FichiersDocument"
// import ModalDocument from './ModalDocument'
import DocumentsTable from "@/components/Bibliotheque/Document/DocumentsTable"
import Multiselect from 'vue-multiselect'

export default {
  name: "Documents",
  components: {
    // DetailsDocument,
    // HistoriqueDocument,
    // FichiersDocument,
    // ModalDocument,
    DocumentsTable,
    Multiselect,
  },
  data() {
    return {
      dataToTransmit: {},
      libelle: '',
      code: '',
      version: '',
      date_debut: '',
      date_fin: '',
      description: '',
      selectedOaps: [],
      oapOptions: [],
      selectedOags: [],
      oagOptions: [],
      nom_fichier: '',
      is_visible_client: false,
      date_publication_journal_officiel: '',
      selectedCategory: null,
      selectedSousCategory: null,
      sousCategoriesOptions: [],
      showSousCategory: false,
      showCodeProduit: false,
      selectedGamme: -1,
      selectedCodeProduit: null,
      selectedRubrique: null,
      selectedSegment: null,
      selectedType: null,
      selectedGarantie: null,
      selectedSousRubrique: null,
      selectedStatus: null,
      categoryOptions: [],
      typeOptions: [],
      gammeOptions: [],
      codesProduit: [],
      codeProduitOptions: [],
      selectedGaranties: [],
      garantieOptions: [
        {value: 'ij', text: 'IJ'},
        {value: 'inval', text: 'Inval'},
        {value: 'dc', text: 'Décès'}
      ],
      rubriqueOptions: [],
      sousRubriqueOptions: [],
      segmentOptions: [],
      statusOptions: [],
      noSearch: 'noSearch',
      allSelected: [],
      selectedRows: [],
      indeterminate: false,
      errors: {
        libelle: '',
        code: '',
        version: '',
        date_debut: '',
        date_fin: '',
        description: '',
        nom_fichier: '',
        is_visible_client: false,
        date_publication_journal_officiel: '',
        selectedCategory: '',
        selectedSousCategory: '',
        selectedGamme: '',
        selectedCodeProduit: '',
        selectedRubrique: '',
        selectedSegment: '',
        selectedType: '',
        selectedGarantie: '',
        selectedSousRubrique: '',
        selectedStatus: '',
        critere_recherche: '',
      },
      document: [],
      modalTitle: 'Création d\'un document',
      isEmpty,
      stateForm: '',
      secteur: []
    };
  },
  async created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
    this.$axios.defaults.headers.common["Accept"] = "application/json";
    this.$axios.defaults.headers.common["Provider"] = getProvider();

    await this.getCategories();
    // await this.getRubriques();
    await this.getSousRubriques();
    await this.getSegments();
    await this.getGammesProduit();
    await this.getStatus();
  },
  async mounted() {
    this.$event.on('refresh-document', () => {
      this.$refs.documents_table.$refs.table.refresh()
    });
    await this.getDataInputSearch()
  },
  computed: {
    tableParam: {
      get() {
        return {
          libelle: this.libelle,
          code: this.code,
          version: this.version,
          date_publication_journal_officiel: this.date_publication_journal_officiel,
          date_debut: this.date_debut,
          date_fin: this.date_fin,
          oap: this.selectedOaps,
          oag: this.selectedOags,
          categorie: this.selectedCategory,
          type: this.selectedType,
          gamme: this.selectedGamme,
          codeProduit: this.selectedCodeProduit,
          garantie: this.selectedGaranties,
          rubrique: this.selectedRubrique,
          sousRubrique: this.selectedSousRubrique,
          segment: this.selectedSegment,
          status: this.selectedStatus,
          secteur: this.secteur,
          // is_visible_client: this.is_visible_client,
          noSearch: this.noSearch,
        };
      }
    },
  },
  watch: {
    selectedRows(newVal, oldVal) {
      // Handle changes in individual checkboxes
      if (newVal.length === 0) {
        this.indeterminate = false
        this.allSelected = false
      } else if (newVal.length === this.$refs['documents_table'].$refs.table.data.length) {
        this.indeterminate = false
        this.allSelected = true
      } else {
        this.indeterminate = true
        this.allSelected = false
      }
    },
    selectedCategory() {
      if (this.selectedCategory) {
        if (this.selectedCategory === 2) {
          this.showSousCategory = true
          this.showCodeProduit = false
          this.getSousCategories()
        } else {
          this.showSousCategory = false
          this.showCodeProduit = true
          this.getRubriques()
        }
        this.getTypes()
      }
    },
    selectedSousCategory() {
      if (this.selectedSousCategory) {
        this.getRubriques()
      }
    },
    selectedGamme() {
      this.codeProduitOptions = []
      if (this.selectedGamme) {
        this.getCodesProduit()
      }
    },
    secteur() {
      this.generateGammeOptions();
    },
  },
  methods: {
    async getDataInputSearch() {
      let self = this;
      // this.$store.commit("IS_LOADING", true)
      await this.$axios
      .get("/espaceBibliotheque/document/getDataInputSearch")
      .then(response => {
        let user = getUser();
        let userOaps = user.profil_active[0].oaps.map(oap => oap.code);
        for (let oap of response.data.oaps) {
          if (userOaps.indexOf(oap.code) > -1) {
            this.oapOptions.push({id: oap.id, name: oap.code + ' (' + oap.structure.libelle + ')'});
          }
        }
        let userOags = user.profil_active[0].oags.map(oag => oag.code);
        for (let oag of response.data.oags) {
          if (userOags.indexOf(oag.code) > -1) {
            this.oagOptions.push({id: oag.id, name: oag.code + ' (' + oag.structure.libelle + ')'});
          }
        }
      })
      .catch(function(error) {
        console.log(error)
        let text = 'Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI.';
        self.$store.commit('IS_LOADING', false)
        self.$swal({ position: 'top', type: 'error', title:'Attention !!', text:text, showConfirmButton: false, timer: 6000})
      });
    },
    /** Fonctions du formulaire de recherche */
    searchByFilters() {
      if (this.validateSearchData()) {
        this.noSearch = ''
        this.$refs.documents_table.$refs.table.refresh()
      }
    },
    validateSearchData() {
      this.clearSearchErrors()
      let valid = true
      console.log(this.secteur)
      if (this.libelle === ''
          && this.code === ''
          && this.version === ''
          && this.date_debut === ''
          && this.date_fin === ''
          && this.date_publication_journal_officiel === ''
          && this.selectedOaps.length === 0
          && this.selectedOags.length === 0
          && this.selectedCategory === null
          && this.selectedType === null
          && this.selectedGamme === -1
          && this.selectedCodeProduit === null
          && this.selectedGaranties.length === 0
          && this.selectedRubrique === null
          && this.selectedSousRubrique === null
          && this.selectedSegment === null
          && this.selectedStatus === null
          && this.secteur.length === 0) {
          valid = false
          this.errors.critere_recherche = 'Vous devez sélectionner au moins un critère de recherche'
      }
      return valid;
    },
    clearSearchErrors() {
      this.errors.libelle = ''
      this.errors.code = ''
      this.errors.version = ''
      this.errors.date_publication_journal_officiel = ''
      this.errors.oap = ''
      this.errors.oag = ''
      this.errors.selectedCategory = ''
      this.errors.selectedSousCategory = ''
      this.errors.selectedType = ''
      this.errors.selectedGamme = ''
      this.errors.selectedGarantie = ''
      this.errors.selectedRubrique = ''
      this.errors.selectedSousRubrique = ''
      this.errors.selectedSegment = ''
      this.errors.critere_recherche = ''
    },
    clearSearchForm() {
      this.noSearch = 'noSearch'
      this.libelle = ''
      this.code = ''
      this.version = ''
      this.date_debut = ''
      this.date_fin = ''
      this.date_publication_journal_officiel = ''
      this.selectedOaps.length === 0
      this.selectedOags.length === 0
      this.selectedCategory = null
      this.selectedSousCategory = null
      this.selectedType = null
      this.selectedGamme = -1
      this.selectedGaranties.length === 0
      this.selectedRubrique = null
      this.selectedSousRubrique = null
      this.selectedSegment = null
      this.selectedStatus = null
      this.is_visible_client = ''
      this.secteur = []
    },
    getCategories() {
      return new Promise((resolve, reject) => {
      let self = this;
      this.$axios
        .get('/espaceBibliotheque/categories')
        .then(response => {
          this.allCategories = response.data.categories;
          this.dataToTransmit.allCategories = response.data.categories;
          for (let row of response.data.categories) {
            this.categoryOptions.push({text: row.libelle, value: row.id});
          }
          resolve();
        })
        .catch(function(error) {
          resolve();
          self.$swal({
              position: "top",
              type: "warning",
              title: "Attention !!",
              text: 'Une erreur est survenue pendant la récupération des catégories de document. Si le problème persiste contactez le support DOSI.',
              showConfirmButton: false,
              timer: 5000
            });
        });
      })
    },
    getSousCategories() {
      return new Promise((resolve, reject) => {
        this.selectedSousCategory = 'null'
        this.sousCategoriesOptions = [];
        // get sous-categorie where categorie_id = this.selectedCategory
        let self = this;
        this.$axios
          .get('/espaceBibliotheque/sous-categories/' + this.selectedCategory)
          .then(response => {
            this.allSousCategories = response.data.sousCategories;
            this.dataToTransmit.allSousCategories = response.data.sousCategories;
            for (let row of response.data.sousCategories) {
              this.sousCategoriesOptions.push({text: row.libelle, value: row.id});
            }
            resolve();
          })
          .catch(function(error) {
            resolve();
            self.$swal({
                position: "top",
                type: "warning",
                title: "Attention !!",
                text: 'Une erreur est survenue pendant la récupération des sous-catégories de document. Si le problème persiste contactez le support DOSI.',
                showConfirmButton: false,
                timer: 5000
              });
          });
      });
    },
    getTypes() {
      return new Promise((resolve, reject) => {
        this.typeOptions = [];
        let self = this;
        this.$axios
          .get('/espaceBibliotheque/types/' + this.selectedCategory)
          .then(response => {
            this.allTypes = response.data.types;
            this.dataToTransmit.allTypes = response.data.types;
            for (let row of response.data.types) {
              this.typeOptions.push({text: row.libelle, value: row.id});
            }
            resolve();
          })
          .catch(function(error) {
            resolve();
            self.$swal({
                position: "top",
                type: "warning",
                title: "Attention !!",
                text: 'Une erreur est survenue pendant la récupération des types de document. Si le problème persiste contactez le support DOSI.',
                showConfirmButton: false,
                timer: 5000
              });
          });
      });
    },
    getRubriques() {
      return new Promise((resolve, reject) => {
        this.rubriqueOptions = [];
        let self = this;
        if (this.selectedCategory == 2) {
          if (!isEmpty(this.selectedSousCategory) && this.selectedSousCategory != 'null') {
            this.$axios
              .get('/espaceBibliotheque/rubriques/bySousCategory/' + this.selectedSousCategory)
              .then(response => {
                this.allRubrique = response.data.rubriques;
                this.dataToTransmit.allRubriques = response.data.rubriques;
                for (let row of response.data.rubriques) {
                  this.rubriqueOptions.push({ text: row.libelle, value: row.id });
                }
                resolve();
              })
              .catch(function (error) {
                resolve();
                self.$swal({
                  position: "top",
                  type: "warning",
                  title: "Attention !!",
                  text: 'Une erreur est survenue pendant la récupération des rubriques de document. Si le problème persiste contactez le support DOSI.',
                  showConfirmButton: false,
                  timer: 5000
                });
              });
          }
        } else {
            this.$axios
            .get('/espaceBibliotheque/rubriques/' + this.selectedCategory)
            .then(response => {
              this.allRubrique = response.data.rubriques;
              this.dataToTransmit.allRubriques = response.data.rubriques;
              for (let row of response.data.rubriques) {
                this.rubriqueOptions.push({ text: row.libelle, value: row.id });
              }
              resolve();
            })
            .catch(function (error) {
              resolve();
              self.$swal({
                position: "top",
                type: "warning",
                title: "Attention !!",
                text: 'Une erreur est survenue pendant la récupération des rubriques de document. Si le problème persiste contactez le support DOSI.',
                showConfirmButton: false,
                timer: 5000
              });
            });
        }
      });
    },
    getSousRubriques() {
      return new Promise((resolve, reject) => {
      let self = this;
      this.$axios
        .get('/espaceBibliotheque/sous-rubriques')
        .then(response => {
          this.allSousRubriques = response.data.sousRubriques;
          this.dataToTransmit.allSousRubriques = response.data.sousRubriques;
          for (let row of response.data.sousRubriques) {
            this.sousRubriqueOptions.push({text: row.libelle, value: row.id});
          }
          resolve();
        })
        .catch(function(error) {
          resolve();
          self.$swal({
              position: "top",
              type: "warning",
              title: "Attention !!",
              text: 'Une erreur est survenue pendant la récupération des sous-rubriques de document. Si le problème persiste contactez le support DOSI.',
              showConfirmButton: false,
              timer: 5000
            });
        });
      })
    },
    getSegments() {
      return new Promise((resolve, reject) => {
      let self = this;
      this.$axios
        .get('/espaceBibliotheque/segments')
        .then(response => {
          this.dataToTransmit.allSegments = response.data.segments;
          for (let row of response.data.segments) {
            this.segmentOptions.push({text: row.libelle, value: row.id});
          }
          resolve();
        })
        .catch(function(error) {
          resolve();
          self.$swal({
              position: "top",
              type: "warning",
              title: "Attention !!",
              text: 'Une erreur est survenue pendant la récupération des segments de document. Si le problème persiste contactez le support DOSI.',
              showConfirmButton: false,
              timer: 5000
            });
        });
      })
    },
    getGammesProduit() {
      return new Promise((resolve, reject) => {
      let self = this;
      this.$axios
        .get('/espaceGestion/produit/gestion-gamme')
        .then(response => {
          this.dataToTransmit.allGammesProduit = response.data.gammesProduit;
          this.gammeOptions.push({text: 'Général', value: null});
          for (let row of response.data.gammesProduit) {
            this.gammeOptions.push({text: row.libelle, value: row.id});
          }
          resolve();
        })
        .catch(function(error) {
          resolve();
          self.$swal({
              position: "top",
              type: "warning",
              title: "Attention !!",
              text: 'Une erreur est survenue pendant la récupération des gammes produit. Si le problème persiste contactez le support DOSI.',
              showConfirmButton: false,
              timer: 5000
            });
        });
      })
    },
    generateGammeOptions() {
      this.gammeOptions = [];
      if (this.secteur.includes('ess')) {
        this.gammeOptions.push({text: 'Général', value: null});
      }

      for (let gamme of this.dataToTransmit.allGammesProduit) {
        if (!isEmpty(this.secteur)) {
          let secteur = gamme.secteur.split(',');
          const filteredArray = secteur.filter(value => this.secteur.includes(value));
          if (!isEmpty(filteredArray)) {
            this.gammeOptions.push({text: gamme.libelle, value: gamme.id});
          }
        } else {
          this.gammeOptions.push({text: gamme.libelle, value: gamme.id});
        }
      }
    },
    getCodesProduit() {
      return new Promise((resolve, reject) => {
      this.codeProduitOptions = []
      let self = this;
      this.$axios
        .get('/espaceGestion/produit/codes-produit/gamme/' + this.selectedGamme)
        .then(response => {
          this.$store.commit('IS_LOADING', false);
          let famillesProduit = response.data.familleProduit
          for (let famille of famillesProduit) {
            for (let produit of famille.produits) {
              this.codeProduitOptions.push({ text: produit.code_produit, value: produit.id });
            }
          }
        })
        .catch(() => {
          self.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: 'Un problème est survenu, merci de contacter l\'administrateur',
            showConfirmButton: false,
            timer: 5000,
          });
        });
      })
    },
    getStatus() {
      return new Promise((resolve, reject) => {
      let self = this;
      this.$axios
        .get('/espaceBibliotheque/document-status')
        .then(response => {
          this.dataToTransmit.allStatus = response.data.status;
          for (let row of response.data.status) {
            this.statusOptions.push({text: row.libelle_bo, value: row.id});
          }
          resolve();
        })
        .catch(function(error) {
          resolve();
          self.$swal({
              position: "top",
              type: "warning",
              title: "Attention !!",
              text: 'Une erreur est survenue pendant la récupération des status de documents. Si le problème persiste contactez le support DOSI.',
              showConfirmButton: false,
              timer: 5000
            });
        });
      })
    },
  }
}
</script>

<style scoped>

</style>
